import { render, staticRenderFns } from "./WealthStatementLoader.vue?vue&type=template&id=7345912a&scoped=true&"
import script from "./WealthStatementLoader.vue?vue&type=script&lang=ts&"
export * from "./WealthStatementLoader.vue?vue&type=script&lang=ts&"
import style0 from "./WealthStatementLoader.vue?vue&type=style&index=0&id=7345912a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7345912a",
  null
  
)

export default component.exports